<script setup>
import {
  onMounted,
  watch,
  ref,
  toRefs,
  onBeforeMount
} from 'vue';
import { useScriptTag } from '@vueuse/core';

import { EMBEDS_URL } from '@/config/appConfig';

const props = defineProps(['settings']);

const { settings } = toRefs(props);

const { load, unload } = useScriptTag(
  `${EMBEDS_URL}/embed/assets/js/embed.js`,
  () => {},
  {
    async: false,
    manual: true,
  },
);

const mounted = ref(false);

onMounted(() => {
  window.tagboardDomain = EMBEDS_URL;
  mounted.value = true;
  if (settings.value.embedId) {
    load();
  }
});

onBeforeMount(() => {
  unload();
});

watch(settings, async (newV, oldV) => {
  // reload script if embedId changes
  if (newV.embedId !== oldV.embedId && mounted.value) {
    await unload();
    await load();
  }
});
</script>
<template>
  <div
    class="tagboard-embed"
    :tgb-embed-id="settings.embedId"
    :key="settings.embedId"
    :data-test="`pages-embed-${settings.embedId}`"
  />
  <!-- <div class="element embed-element">Embed</div> -->
</template>
